import tagsTypes from "constants/tagsTypes";

const getEntityParams = values => {
  const params = {
    companyIds: [],
    departmentIds: [],
    interestIds: [],
    locationIds: [],
    organizationIds: [],
    skillIds: [],
    userIds: [],
    classYears: [],
    clubs: [],
    programsprogram: [],
    degrees: []
  };

  values.forEach(value => {
    switch (value.category) {
      case "companies":
        params.companyIds.push(value.value);
        break;
      case "departments":
        params.departmentIds.push(value.value);
        break;
      case "interests":
        params.interestIds.push(value.value);
        break;
      case "locations":
        params.locationIds.push(value.value);
        break;
      case "skills":
        params.skillIds.push(value.value);
        break;
      case "classYears":
      case "class years":
        params.classYears.push(value.value);
        break;
      case "clubs":
        params.clubs.push(value.value);
        break;
      case "programs":
        params.programs.push(value.value);
        break;
      case "degrees":
        params.degrees.push(value.value);
        break;
      case tagsTypes.ALL_ORGANIZATION:
        params.organizationIds.push(value.value);
        break;
      default:
        params.userIds.push(value.value);
        break;
    }
  });

  return params;
};

export default getEntityParams;
